var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 13",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3202_37373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31428 8.03838V12.4156C6.33928 12.5822 6.27678 12.76 6.13305 12.8766C6.07524 12.9281 6.00657 12.969 5.93097 12.9968C5.85538 13.0247 5.77433 13.0391 5.69249 13.0391C5.61065 13.0391 5.52961 13.0247 5.45401 12.9968C5.37841 12.969 5.30974 12.9281 5.25193 12.8766L3.99585 11.7601C3.92769 11.7009 3.87587 11.6284 3.84443 11.5485C3.813 11.4685 3.80279 11.3831 3.81463 11.2991V8.03838H3.79588L0.196377 3.93894C0.0948963 3.82314 0.0491061 3.67634 0.0690122 3.53062C0.0889183 3.38491 0.172902 3.25211 0.302612 3.16127C0.421346 3.0835 0.552578 3.03906 0.690059 3.03906H9.43885C9.57633 3.03906 9.70756 3.0835 9.82629 3.16127C9.956 3.25211 10.04 3.38491 10.0599 3.53062C10.0798 3.67634 10.034 3.82314 9.93253 3.93894L6.33303 8.03838H6.31428Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.06445,
    y: 1.11523,
    width: 1.52147,
    height: 12.8854,
    rx: 0.760734,
    transform: "rotate(-45 1.06445 1.11523)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3202_37373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 13,
    transform: "translate(0.0214844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterClose);
export default __webpack_public_path__ + "static/media/filter-close.70cd5bc47ca53abbfd1dd6fd503e9da9.svg";
export { ForwardRef as ReactComponent };